/* KIAURA restock alerts: first-party Klaviyo Back In Stock.
   Markup comes from snippets/kiaura-restock.liquid. Every listener is delegated on document,
   so a colorway AJAX swap needs no re-init: the swapped section brings its own widget. */
(function () {
  if (window.__kiauraRestock) return;
  window.__kiauraRestock = true;

  var KLAVIYO_COMPANY = 'Yg3gTU';
  var ENDPOINT = 'https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=' + KLAVIYO_COMPANY;
  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  function variantsOf(widget) {
    if (widget.__krVariants) return widget.__krVariants;
    var tag = widget.querySelector('[data-kr-variants]');
    try { widget.__krVariants = JSON.parse(tag.textContent); } catch (e) { widget.__krVariants = []; }
    return widget.__krVariants;
  }

  function selectedVariantId(widget) {
    var section = widget.closest('.shopify-section') || document;
    var input = section.querySelector('form.js-product-form [name="id"]') || section.querySelector('form [name="id"]');
    return input ? parseInt(input.value, 10) : null;
  }

  function variantFor(widget, id) {
    var list = variantsOf(widget);
    for (var i = 0; i < list.length; i++) if (list[i].id === id) return list[i];
    return null;
  }

  function sync(widget) {
    var v = variantFor(widget, selectedVariantId(widget));
    if (!v) return;
    var trigger = widget.querySelector('[data-kr-open]');
    if (trigger) trigger.hidden = !!v.available;
  }

  function syncAll(root) {
    (root || document).querySelectorAll('[data-kr]').forEach(sync);
  }

  /* The modal is moved to <body> on first open: transforms inside the product section would
     otherwise trap position:fixed. Once portaled it is no longer inside the widget, so it is
     resolved through this cache, never by querySelector on the widget. */
  function modalFor(widget) {
    if (widget.__krModal && document.body.contains(widget.__krModal)) return widget.__krModal;
    var modal = widget.querySelector('[data-kr-modal]');
    if (!modal) return null;
    document.querySelectorAll('body > [data-kr-modal]').forEach(function (m) {
      if (!m.__krWidget || !document.body.contains(m.__krWidget)) m.remove();
    });
    modal.__krWidget = widget;
    document.body.appendChild(modal);
    widget.__krModal = modal;
    return modal;
  }

  var lastFocus = null;

  function open(widget) {
    var modal = modalFor(widget);
    if (!modal) return;
    var v = variantFor(widget, selectedVariantId(widget));
    modal.__krVariantId = v ? v.id : selectedVariantId(widget);
    var label = modal.querySelector('[data-kr-variant-label]');
    if (label) label.textContent = v && v.options ? v.options.join(' · ') : (widget.getAttribute('data-kr-color') || '');
    modal.querySelector('[data-kr-body]').hidden = false;
    modal.querySelector('[data-kr-done]').hidden = true;
    showError(modal, '');
    lastFocus = document.activeElement;
    modal.hidden = false;
    document.documentElement.classList.add('kr-lock');
    var input = modal.querySelector('[data-kr-email]');
    if (input) setTimeout(function () { input.focus(); }, 30);
  }

  function close(modal) {
    if (!modal || modal.hidden) return;
    modal.hidden = true;
    document.documentElement.classList.remove('kr-lock');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function showError(modal, msg) {
    var el = modal.querySelector('[data-kr-error]');
    if (!el) return;
    el.textContent = msg;
    el.hidden = !msg;
  }

  function submit(modal) {
    var input = modal.querySelector('[data-kr-email]');
    var btn = modal.querySelector('[data-kr-submit]');
    var email = (input.value || '').trim();
    if (!EMAIL_RE.test(email)) { showError(modal, 'Enter a valid email address.'); input.focus(); return; }
    if (!modal.__krVariantId) { showError(modal, 'Something went wrong. Refresh and try again.'); return; }
    showError(modal, '');
    btn.disabled = true;
    btn.setAttribute('aria-busy', 'true');

    fetch(ENDPOINT, {
      method: 'POST',
      referrerPolicy: 'no-referrer',
      headers: { 'Content-Type': 'application/json', revision: '2024-10-15' },
      body: JSON.stringify({
        data: {
          type: 'back-in-stock-subscription',
          attributes: {
            channels: ['EMAIL'],
            profile: { data: { type: 'profile', attributes: { email: email } } }
          },
          relationships: {
            variant: { data: { type: 'catalog-variant', id: '$shopify:::$default:::' + modal.__krVariantId } }
          }
        }
      })
    })
      .then(function (res) {
        if (!res.ok) throw new Error('HTTP ' + res.status);
        modal.querySelector('[data-kr-body]').hidden = true;
        modal.querySelector('[data-kr-done]').hidden = false;
      })
      .catch(function () {
        showError(modal, 'Something went wrong. Please try again.');
      })
      .then(function () {
        btn.disabled = false;
        btn.removeAttribute('aria-busy');
      });
  }

  document.addEventListener('click', function (e) {
    var openBtn = e.target.closest('[data-kr-open]');
    if (openBtn) { e.preventDefault(); open(openBtn.closest('[data-kr]')); return; }
    var modal = e.target.closest('[data-kr-modal]');
    if (!modal) return;
    if (e.target.closest('[data-kr-close]')) { e.preventDefault(); close(modal); return; }
    if (e.target.closest('[data-kr-submit]')) { e.preventDefault(); submit(modal); }
  });

  document.addEventListener('keydown', function (e) {
    var modal = document.querySelector('body > [data-kr-modal]:not([hidden])');
    if (!modal) return;
    if (e.key === 'Escape') { close(modal); return; }
    if (e.key === 'Enter' && e.target.matches('[data-kr-email]')) { e.preventDefault(); submit(modal); }
  });

  /* Size/colour change inside a product (the theme's variant picker). */
  document.addEventListener('on:variant:change', function (e) {
    var section = e.target.closest ? e.target.closest('.shopify-section') : null;
    syncAll(section || document);
  });

  /* A colorway swap drops a brand-new widget into the page. */
  new MutationObserver(function (records) {
    for (var i = 0; i < records.length; i++) {
      var added = records[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        var n = added[j];
        if (n.nodeType === 1 && (n.matches('[data-kr]') || n.querySelector('[data-kr]'))) { syncAll(n.matches('[data-kr]') ? n.parentNode : n); }
      }
    }
  }).observe(document.body, { childList: true, subtree: true });

  syncAll();
})();
